const QUOTE_PRODUCT_TYPE_COLORS = {
  ROOM: { bg: "#eef4fb", accent: "#5c8fd6" },
  MEAL: { bg: "#fef6ee", accent: "#e0984a" },
  EXCURSION: { bg: "#eef8f0", accent: "#5da86a" },
  TOUR: { bg: "#f3eefb", accent: "#8e6bc7" },
  TOUR_LEADER: { bg: "#f0eef8", accent: "#7b6bb5" },
  TRANS: { bg: "#eef8f8", accent: "#4a9ea8" },
  EXPENSE: { bg: "#f5f2ef", accent: "#9a8b7a" },
};

function getQuoteProductTypeColors(productType) {
  return QUOTE_PRODUCT_TYPE_COLORS[productType] || { bg: "#f7f7f7", accent: "#bdbdbd" };
}

function getQuoteProductTypeCssVars(productType) {
  const { bg, accent } = getQuoteProductTypeColors(productType);
  return {
    "--quote-product-type-bg": bg,
    "--quote-product-type-accent": accent,
  };
}

export { getQuoteProductTypeColors, getQuoteProductTypeCssVars };
